import ApiService from "src/app/model/api/generic/apiService";
import RequestOtp from "src/app/model/api/otp/requestOtp";

export default class OtpService extends ApiService {

  public async generarCodigo(req: RequestOtp): Promise<boolean> {
    return await this.service.HttpPost('/api/otp/postgenerarcodigo', req)
  }

  public async validarCodigo(codigo: String): Promise<number> {
    return await this.service.HttpGet('/api/otp/getcodigovalido', {
      codigo: codigo
    })
  }

}